export interface NewsFilter {
  readonly key: "author" | "tag";
  readonly value: {
    readonly raw: string,
    readonly display: string,
  };
}

export function isEqualNewsFilter(a: NewsFilter, b: NewsFilter): boolean {
  return a.key === b.key && a.value.raw === b.value.raw;
}
